import type { User } from "@/domain/user";
import { apiClientJSON } from "../apiClient";

export const getUser = (userId: number): Promise<User> => {
  return apiClientJSON
    .get(`/account-service/dashboard/users/${userId}`)
    .then((r) => r.data);
};

export const getUsersList = (
  search: string,
  whiteLabelId?: number
): Promise<User[]> => {
  return apiClientJSON
    .get("/account-service/dashboard/users", {
      params: {
        page: 0,
        size: 20,
        search,
        ...(whiteLabelId && { whiteLabelId }),
      },
    })
    .then((r) => r.data?.content || []);
};

export const getAllUsers = (): Promise<User[]> => {
  return apiClientJSON
    .get("/payment-service/dashboard/users", {
      params: {
        page: 0,
        size: 20000,
      },
    })
    .then((r) => r.data?.content || []);
};
